import { api } from '../baseApi';
import { arrayParamsSerializer } from '../helpers';
import { makeRequest } from '../makeRequest';
import type { IMedscapeMetadata } from '../workspaces';
import type {
  DownloadReachAnalysisRequest,
  GetAvailableAttributesResponse,
  GetColumnSuggestionsRequest,
  GetColumnSuggestionsResponse,
  GetColumnsRequest,
  GetColumnsResponse,
  GetPreviewRequest,
  GetPreviewResponse,
  GetReservedColumnsResponse,
  MapDataRequest,
  MapDataResponse,
  PublishRequest,
  PublishResponse,
  SegmentationRequest,
  SegmentationResponse,
} from './dto';
import { ListMatchingAPIRoutes } from './route';

export function getColumns(params: GetColumnsRequest): Promise<GetColumnsResponse> {
  return makeRequest(
    api.get(ListMatchingAPIRoutes.columns(), {
      params,
    }),
  );
}

export function getAvailableAttributes(): Promise<GetAvailableAttributesResponse> {
  return makeRequest(api.get(ListMatchingAPIRoutes.availableAttributes()));
}

export function mapData(body: MapDataRequest, medscapeData?: IMedscapeMetadata): Promise<MapDataResponse> {
  const { deliverable, ...medscapeMetadata } = medscapeData ?? {};

  return makeRequest(
    api.post(ListMatchingAPIRoutes.mapData(), {
      ...body,
      ...medscapeMetadata,
      deliverableID: deliverable,
    }),
  );
}

export function getColumnSuggestions(params: GetColumnSuggestionsRequest): Promise<GetColumnSuggestionsResponse> {
  return makeRequest(
    api.get(ListMatchingAPIRoutes.columnSuggestions(), {
      params,
      paramsSerializer: arrayParamsSerializer,
    }),
  );
}

export function updateSegmentation(
  body: SegmentationRequest,
  medscapeData?: IMedscapeMetadata,
): Promise<SegmentationResponse> {
  const { deliverable, ...medscapeMetadata } = medscapeData ?? {};

  return makeRequest(
    api.post(ListMatchingAPIRoutes.segmentation(), {
      ...body,
      ...medscapeMetadata,
      segments: body.segments.map((segment) => ({
        ...segment,
        name: segment.id,
        id: undefined,
      })),
      deliverableID: deliverable,
    }),
  );
}

export function getPreview(params: GetPreviewRequest): Promise<GetPreviewResponse> {
  return makeRequest(api.get(ListMatchingAPIRoutes.preview(), { params }));
}

export function getReservedColumns(): Promise<GetReservedColumnsResponse> {
  return makeRequest(api.get(ListMatchingAPIRoutes.reservedColumns()));
}

export function publish(params: PublishRequest): Promise<PublishResponse> {
  return makeRequest(
    api.get(ListMatchingAPIRoutes.publish(), {
      params,
    }),
  );
}

export function downloadReachAnalysis(params: DownloadReachAnalysisRequest): Promise<string> {
  return makeRequest(
    api.get(ListMatchingAPIRoutes.download(), {
      responseType: 'blob',
      params,
      transformResponse: (data) => {
        return URL.createObjectURL(data);
      },
    }),
  );
}
